import { ValidationService } from '../../scripts/aspnet-validation';

// Create the validation service
let v = new ValidationService();

// Declare and register any custom validators

const mustbetrue = function (value, element, params) {
    if (element.type && element.type === 'checkbox') {
        return element.checked;
    }
    return !value;
};

v.addProvider("mustbetrue", mustbetrue);

// Initialize
v.bootstrap();